// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as EditOrderCmp from "../edit-order/EditOrderCmp.bs.js";
import * as CancelOrderCmp from "../cancel-order/CancelOrderCmp.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DeliveryNoteCmp from "../delivery-note/DeliveryNoteCmp.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as EditOrderAssetsManager from "../../assets/EditOrderAssetsManager.bs.js";
import * as EditOrderSidebarHeader from "./EditOrderSidebarHeader.bs.js";
import * as EditOrderSidebarTabManager from "./EditOrderSidebarTabManager.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

EditOrderAssetsManager.importCss(undefined);

function EditOrderSidebar(Props) {
  var crn = Props.crn;
  var order = Props.order;
  var user = Props.user;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var openSnackbar = Props.openSnackbar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = EditOrderSidebarTabManager.useSidebar(undefined);
  var active_edit_order_tab = match$1[0];
  var match$2 = React.useState(function () {
        return /* Init */0;
      });
  var setOrderFare = match$2[1];
  var order_fare = match$2[0];
  React.useEffect((function () {
          var exit = 0;
          switch (order.TAG | 0) {
            case /* Open */0 :
            case /* Accepted */1 :
            case /* Live */2 :
            case /* Ended */3 :
                exit = 1;
                break;
            default:
              
          }
          if (exit === 1) {
            Curry._1(setOrderFare, (function (param) {
                    return {
                            TAG: /* Loading */0,
                            _0: undefined
                          };
                  }));
            EditOrderDataMachine.fetchOrderFareBreakup(crn, (function (data) {
                    return Curry._1(setOrderFare, (function (param) {
                                  return {
                                          TAG: /* Live */1,
                                          _0: data
                                        };
                                }));
                  }), (function (error) {
                    return Curry._1(setOrderFare, (function (param) {
                                  return {
                                          TAG: /* Error */2,
                                          _0: error
                                        };
                                }));
                  }), country);
          }
          
        }), []);
  var tmp;
  var exit = 0;
  switch (order.TAG | 0) {
    case /* Open */0 :
    case /* Accepted */1 :
    case /* Live */2 :
    case /* Ended */3 :
        exit = 1;
        break;
    default:
      var tmp$1;
      switch (active_edit_order_tab) {
        case /* EditOrder */0 :
            tmp$1 = React.createElement(EditOrderCmp.make, {
                  crn: crn,
                  order: order,
                  order_fare: undefined,
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  changeDiscardModalState: changeDiscardModalState,
                  openSnackbar: openSnackbar
                });
            break;
        case /* CancelOrder */1 :
            tmp$1 = React.createElement(CancelOrderCmp.make, {
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  changeDiscardModalState: changeDiscardModalState,
                  order: order,
                  openSnackbar: openSnackbar
                });
            break;
        case /* DeliveryNote */2 :
            tmp$1 = React.createElement(DeliveryNoteCmp.make, {
                  order: order,
                  user: user,
                  toggleEditOrderSidebar: toggleEditOrderSidebar,
                  changeDiscardModalState: changeDiscardModalState,
                  openSnackbar: openSnackbar
                });
            break;
        
      }
      tmp = React.createElement("div", {
            className: "c-edit-order-sidebar "
          }, tmp$1);
  }
  if (exit === 1) {
    if (typeof order_fare === "number") {
      tmp = null;
    } else {
      switch (order_fare.TAG | 0) {
        case /* Loading */0 :
            tmp = React.createElement(LoadingViewComponent$Catalyst.make, {});
            break;
        case /* Live */1 :
            var tmp$2;
            switch (active_edit_order_tab) {
              case /* EditOrder */0 :
                  tmp$2 = React.createElement(EditOrderCmp.make, {
                        crn: crn,
                        order: order,
                        order_fare: order_fare._0,
                        toggleEditOrderSidebar: toggleEditOrderSidebar,
                        changeDiscardModalState: changeDiscardModalState,
                        openSnackbar: openSnackbar
                      });
                  break;
              case /* CancelOrder */1 :
                  tmp$2 = React.createElement(CancelOrderCmp.make, {
                        toggleEditOrderSidebar: toggleEditOrderSidebar,
                        changeDiscardModalState: changeDiscardModalState,
                        order: order,
                        openSnackbar: openSnackbar
                      });
                  break;
              case /* DeliveryNote */2 :
                  tmp$2 = React.createElement(DeliveryNoteCmp.make, {
                        order: order,
                        user: user,
                        toggleEditOrderSidebar: toggleEditOrderSidebar,
                        changeDiscardModalState: changeDiscardModalState,
                        openSnackbar: openSnackbar
                      });
                  break;
              
            }
            tmp = React.createElement("div", {
                  className: "c-edit-order-sidebar "
                }, tmp$2);
            break;
        case /* Error */2 :
            tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: order_fare._0
                });
            break;
        
      }
    }
  }
  return React.createElement("div", undefined, React.createElement(EditOrderSidebarHeader.make, {
                  crn: crn,
                  active_edit_order_tab: active_edit_order_tab,
                  changeEditOrderTab: match$1[1]
                }), tmp);
}

var make = EditOrderSidebar;

export {
  make ,
  
}
/*  Not a pure module */
